import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useEngagementInsightsData } from 'modules/engagement_insights/hooks/useEngagementInsightsData'

const HelpCenterWidget = () => {
  const HELP_CENTER_URL = 'https://help.factorialhr.com/about-the-engagement-insight-dashboard'
  const SHARE_FEEDBACK_URL = 'https://factorial.canny.io/feature-requests'

  const { climate, enps } = useEngagementInsightsData()

  const trackAmplitudeEvents = (eventName: string) => {
    track(eventName, {
      enps_status: enps?.attributes.state,
      climate_status: climate?.attributes.status,
    })
  }

  const goToHC = () => {
    trackAmplitudeEvents(trackingEvents.engagementInsights.goToHC)
    window.open(HELP_CENTER_URL)
  }

  const goToShareFeedback = () => {
    trackAmplitudeEvents(trackingEvents.engagementInsights.goToShareFeedback)
    window.open(SHARE_FEEDBACK_URL)
  }

  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      style={{ flex: '1 1 0' }}
      height="fit-content"
      padding="s24"
    >
      <Box>
        <Text htmlTag="p" weight="medium" color="grey800" size="300">
          {i18n.t('engagement_insights.help_center_widget.title')}
        </Text>
        <Box style={{ paddingTop: '55px' }}>
          <Button type="secondary" onClick={() => goToHC()}>
            {i18n.t('engagement_insights.help_center_widget.go_to_help_center')}
          </Button>
        </Box>
        <Box style={{ paddingTop: '8px' }}>
          <Button type="secondary" onClick={() => goToShareFeedback()}>
            {i18n.t('engagement_insights.help_center_widget.share_feedback')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default HelpCenterWidget
